// extracted by mini-css-extract-plugin
export default {"button":"SelectionActionButton_button__UKBgQP2W","icon":"SelectionActionButton_icon__D7+zScfs","text":"SelectionActionButton_text__Xf+Ywhb0"};